import { getTestimonials } from 'api/user/profile-api'
import React, { useState, useCallback } from 'react'
import { FaAngleDown } from 'react-icons/fa6'
import { CustomerReviews } from '../../commons/CustomerReviews'
import { GoogleRatingBadge } from '@/commons/service-hub/ReviewsSection'

// UAE / Malaysia pass `title`, `intro` and `showRating` (features.googleRating);
// Singapore passes none.
export const AirconCustomerReviews = (props) => {
    const { title, intro, showRating = true } = props
    const [testimonials, setTestimonials] = useState(props.testimonials)
    const [pageNumber, setPageNumber] = useState(9)
    const pageSize = 6
    const [isShowLoadMore, setIsShowLoadMore] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const loadMoreReviews = useCallback(async () => {
        if (isLoading || !isShowLoadMore) return
        setIsLoading(true)
        try {
            const response = await getTestimonials("Aircon Services", pageNumber, pageSize)
            if (response && response.length > 0) {
                setPageNumber(prev => prev + pageSize)
                setTestimonials(prev => [...prev, ...response])
            }
            if (!response || response.length < pageSize) {
                setIsShowLoadMore(false)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }, [isLoading, isShowLoadMore, pageNumber])

    // Wrapper for CustomerReviews scroll-based load more (returns Promise)
    const handleScrollLoadMore = async () => {
        return loadMoreReviews()
    }

    return (
        <section className="relative py-10 md:py-16 overflow-hidden bg-linear-to-b from-orange-50/60 via-white to-amber-50/40">
            {/* Decorative glass blobs */}
            <div className="relative max-w-6xl mx-auto px-4">
                {/* Section Header */}
                <div className="text-center mb-8 md:mb-10">
                    <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-1.5 rounded-full border border-orange-100 shadow-sm mb-4">
                        <span className="text-sm">⭐</span>
                        <span className="text-xs font-semibold text-orange-600 tracking-wide uppercase">Verified Reviews</span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-3 tracking-tight">
                        {title ?? 'Trusted by Homeowners in Singapore'}
                    </h2>
                    <p className="text-sm text-gray-500 max-w-lg mx-auto">
                        {intro ?? 'Real feedback from customers who booked aircon servicing through StringsSG'}
                    </p>

                    {/* Rating and count come from utils/business-info. This used to be a hardcoded 4.9. */}
                    {showRating && <GoogleRatingBadge variant="glass" className="mt-5" />}
                </div>

                {/* Reusable CustomerReviews — Light Theme */}
                <CustomerReviews
                    testimonials={testimonials}
                    onLoadMore={handleScrollLoadMore}
                    isLoadingExternal={isLoading}
                    hasMoreExternal={isShowLoadMore}
                    theme="light"
                    providerLabel="Technician"
                />

                {/* Show More Reviews — Desktop only */}
                {isShowLoadMore && (
                    <div className="hidden md:block text-center mt-8">
                        <button
                            type="button"
                            onClick={loadMoreReviews}
                            disabled={isLoading}
                            aria-label="Load more reviews"
                            className="inline-flex items-center gap-2 px-6 py-3 text-orange-600 hover:text-orange-700 font-semibold rounded-full bg-white/60 hover:bg-white/80 backdrop-blur-md border border-orange-200/50 shadow-sm hover:shadow-md transition-all duration-300 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <>
                                    <div className="w-4 h-4 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
                                    Loading...
                                </>
                            ) : (
                                <>
                                    Show More Reviews
                                    <FaAngleDown />
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        </section>
    )
}
